import React, { useState } from 'react';
import {
  Paper,
  Typography,
  Box,
  Grid,
  TextField,
  Button,
  Chip,
} from '@mui/material';
import { PersonAdd as PersonAddIcon, Group as GroupIcon } from '@mui/icons-material';

export function StudentManager({ currentGroup, onUpdate }) {
  const [name, setName] = useState('');
  const [id, setId] = useState('');
  const addStudent = () => {
    if (name && id) {
      const updated = {
        ...currentGroup,
        students: [...currentGroup.students, { name, studentId: id }],
      };
      onUpdate(updated);
      setName('');
      setId('');
    }
  };
  return (
    <Paper sx={{ p: 3, mb: 4, bgcolor: '#f5f5f5' }}>
      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
        <GroupIcon sx={{ mr: 1 }} /> Team Members
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
        {currentGroup.students.map((s, i) => (
          <Chip
            key={s.studentId || i}
            label={`${s.name} (${s.studentId})`}
            color="primary"
            variant="outlined"
            onDelete={() => {
              const newStudents = [...currentGroup.students];
              newStudents.splice(i, 1);
              onUpdate({ ...currentGroup, students: newStudents });
            }}
          />
        ))}
        {currentGroup.students.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            No students added yet.
          </Typography>
        )}
      </Box>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={5}>
          <TextField
            fullWidth
            size="small"
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            fullWidth
            size="small"
            label="ID"
            value={id}
            onChange={(e) => setId(e.target.value)}
          />
        </Grid>
        <Grid item xs={3}>
          <Button
            variant="contained"
            startIcon={<PersonAddIcon />}
            onClick={addStudent}
            fullWidth
          >
            Add
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}
